import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import cn from 'classnames';
import { Button, Checkbox } from '../../atoms';
import { FormControl } from 'react-bootstrap';
import { UserSearchFilters } from '../../../utils/types/types';
import { MultiSelectWithFiltering } from '../../molecules';
import { Role } from '../../../store/contextAPI/role/dto/response/role.dto';
import { getRoleSeparation } from '../../../utils/Helpers/role-helper';
import styles from './UserManagementUsersFilterOrganism.module.css';

interface UserManagementUsersFilterOrganismProps {
  filters?: UserSearchFilters;
  roles: Role[];
  handleSearch: (filters: UserSearchFilters) => void;
  onSetIsInactive: Dispatch<SetStateAction<boolean>>;
}

const UserManagementUsersFilterOrganism: FC<
  UserManagementUsersFilterOrganismProps
> = ({ roles, filters, handleSearch, onSetIsInactive }) => {
  const [searchTerm, setSearchTerm] = useState(filters?.searchTerm);
  const [roleIds, setRoleIds] = useState<string[] | undefined>(
    filters?.roleIds
  );
  const [isInactive, setIsInactive] = useState<boolean | undefined>(
    filters?.isInactive
  );

  const triggerSearch = (shouldReset = false) => {
    if (shouldReset) {
      setIsInactive(false);
      setRoleIds([]);
      setSearchTerm('');

      handleSearch({
        searchTerm: '',
        isInactive: false,
        roleIds: undefined,
      });
      return;
    }
    handleSearch({ searchTerm, isInactive, roleIds });
  };

  useEffect(() => {
    if (filters?.isInactive) onSetIsInactive(true);
    else onSetIsInactive(false);
  }, [filters?.isInactive, isInactive, onSetIsInactive]);

  const options =
    roles?.map((role) => ({
      label: getRoleSeparation(role.name),
      value: role.id,
    })) ?? [];

  const defaultValues =
    options.filter((option) => roleIds?.includes(option.value)) || [];

  return (
    <div className={cn(styles.usersWrapper)}>
      <div className={cn(styles.inputFieldWrapper)}>
        <FormControl
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className={cn(styles.inputFieldWrapper)}>
        <MultiSelectWithFiltering
          name="roles"
          inputId="roles"
          placeholder="Select roles..."
          options={options}
          value={defaultValues}
          onSelect={(selectedValues) => {
            const selected = selectedValues.map((role) => role.value);
            setRoleIds(selected);
          }}
        />
      </div>
      <div className={cn(styles.checkBoxWrapper)}>
        <Checkbox
          id="inactiveUserCheckbox"
          label="Show inactive users"
          onChange={(checked) => {
            setIsInactive(checked);
          }}
          checked={isInactive}
        />
      </div>
      <div className={cn(styles.buttonsWrapper)}>
        <Button
          className={cn(styles.button)}
          onClick={() => triggerSearch()}
          variant="dark"
        >
          Search
        </Button>
        <Button
          onClick={() => triggerSearch(true)}
          variant="light"
          className={cn(styles.button)}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default UserManagementUsersFilterOrganism;
